import StorageService from '@/services/StorageService';
import router from '@/router';

const state = {};

// Getter functions
const getters = {};

// Mutations
const mutations = {};

// Actions
const actions = {
  logout({ dispatch }, payload) {
    dispatch('settings/changeLoggedIn', false, { root: true });
    dispatch('settings/changeImgId', null, { root: true });
    dispatch('common/clearAll', null, { root: true });
    dispatch('settings/clearAll', null, { root: true });

    StorageService.performLogoutCleanup();

    if (!(payload && payload.noRedirect)) {
      router.push({
        name: 'login',
        query: { reload: 1 },
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
